export default __webpack_public_path__ + "static/media/opener.20dd698d.svg";